import { all, fork } from 'redux-saga/effects'
import * as constants from './constants'
import * as profile from './profile'
import * as campaigns from './campaigns'
import * as submissions from './submissions'
import * as tasks from './tasks'
import * as brands from './brands'
import * as teams from './teams'
import * as partiposter from './partiposter'
import * as registrations from './registrations'
import * as banners from './banners'
import * as filters from './filter'
import * as campaignTemplates from './campaignTemplates'
import * as register from './register'
import * as campaignReport from './campaignReport'
import * as ambassador from './ambassadors'

export default function* sagas(): any {
    yield all([
        fork(constants.watchConstantsRequestFlow),
        fork(constants.watchLocationOptionsRequestFlow),
        fork(constants.watchAddCustomTag),
        fork(constants.watchProfileOptionsRequestFlow),
        fork(constants.watchGetTags),
        fork(constants.watchGetOnboardingOptions),
        fork(profile.watchLoginRequestFlow),
        fork(profile.watchLogoutRequestFlow),
        fork(profile.watchProfileRequestFlow),
        fork(profile.watchResetPasswordRequestFlow),
        fork(profile.watchUpdatePasswordRequestFlow),
        fork(profile.watchVerifyTokenRequestFlow),
        fork(profile.watchGoogleAuthRequestFlow),
        fork(campaigns.watchCampaignsListRequestFlow),
        fork(campaigns.watchCampaignRequestFlow),
        fork(campaigns.watchCampaignSummaryRequestFlow),
        fork(campaigns.watchCampaignProgressRequestFlow),
        fork(campaigns.watchExportCampaignProgressRequestFlow),
        fork(campaigns.watchCampaignPerformanceRequestFlow),
        fork(campaigns.watchGetCampaignPerformanceFiltersRequestFlow),
        fork(campaigns.watchExportCampaignPerformanceRequestFlow),
        fork(campaigns.watchExportCampaignOverview),
        fork(campaigns.watchSubmissionsSummaryRequestFlow),
        fork(campaigns.watchRegisterCampaignRequestFlow),
        fork(campaigns.watchUpdateCampaignRequestFlow),
        fork(campaigns.watchUpdatePayoutDeadlineFlow),
        fork(campaigns.watchUpdateProfileRecommendationSettingRequestFlow),
        fork(campaigns.watchSubmitCampaignRequestFlow),
        fork(campaigns.watchPublishCampaignRequestFlow),
        fork(campaigns.watchSendCampaignToEditRequestFlow),
        fork(campaigns.watchSendCampaignToPaymentRequestFlow),
        fork(campaigns.watchSendCampaignBackToReviewFlow),
        fork(campaigns.watchSetCampaignSubmissionStatusFlow),
        fork(campaigns.watchSetAutoSubmissionStatusFlow),
        fork(campaigns.watchCloseCampaignFlow),
        fork(campaigns.watchEndCampaignFlow),
        fork(campaigns.watchCampaignSubmissionsSummaryFlow),
        fork(campaigns.watchBlockedCampaignCheckRequestFlow),
        fork(campaigns.watchUpdateCampaignSlots),
        fork(campaigns.watchDuplicateCampaignFlow),
        fork(campaigns.watchDeleteCampaignFlow),
        fork(submissions.watchSubmissionsPageListRequestFlow),
        fork(submissions.watchSubmissionsPageFiltersRequestFlow),
        fork(submissions.watchBatchSubmissionsPageListRequestFlow),
        fork(submissions.watchGetCampaignPerformanceFiltersRequestFlow),
        fork(submissions.watchDropoutsListRequestFlow),
        fork(submissions.watchRejectedListRequestFlow),
        fork(submissions.watchRejectedAndDropoutsListRequestFlow),
        fork(submissions.watchRejectSubmissionFlow),
        fork(submissions.watchRequestEditsForSubmissionFlow),
        fork(submissions.watchApproveSubmissionFlow),
        fork(submissions.watchUploadCompletedScheduleFlow),
        fork(submissions.watchMassSubmissionFlow),
        fork(submissions.watchMassRejectAllSubmissionFlow),
        fork(submissions.watchGetDiscussSubmissionFlow),
        fork(submissions.watchCreateDiscussSubmissionFlow),
        fork(submissions.watchUpdateDiscussSubmissionFlow),
        fork(submissions.watchDeleteDiscussSubmissionFlow),
        fork(submissions.watchVoteSubmissionFlow),
        fork(submissions.watchReviewPendingActionFlow),
        fork(submissions.watchUpdateSubmissionPerformanceFlow),
        fork(submissions.watchPaySubmissionFlow),
        fork(submissions.watchRejectSubmissionPayoutFlow),
        fork(submissions.watchExportSubmissionsRequestFlow),
        fork(submissions.watchMassPayoutSubmissionFlow),
        fork(submissions.watchGetEditRequestHistoryList),
        fork(submissions.watchReviewCaptionFlow),
        fork(submissions.watchExtendFirstStepDeadline),
        fork(tasks.watchTasksListRequestFlow),
        fork(tasks.watchRegisterTaskRequestFlow),
        fork(tasks.watchUpdateTaskRequestFlow),
        fork(tasks.watchDeleteTaskRequestFlow),
        fork(tasks.watchUpdateTaskPayoutsRequestFlow),
        fork(tasks.watchUpdateTaskSchedulesRequestFlow),
        fork(tasks.watchUpdateTasksOrdering),
        fork(brands.watchGetBrandRequestFlow),
        fork(brands.watchBrandsListRequestFlow),
        fork(brands.watchCreateBrandRequestFlow),
        fork(brands.watchUpdateBrandRequestFlow),
        fork(teams.watchTeamsListRequestFlow),
        fork(teams.watchGetTeamRequestFlow),
        fork(teams.watchCreateTeamRequestFlow),
        fork(teams.watchUpdateTeamRequestFlow),
        fork(teams.watchUpdateTeamTypeRequestFlow),
        fork(teams.watchDeleteTeamRequestFlow),
        fork(teams.watchCreateMemberRequestFlow),
        fork(teams.watchUpdateMemberRequestFlow),
        fork(teams.watchDeleteMemberRequestFlow),
        fork(teams.watchRemoveTeamMemberRequestFlow),
        fork(teams.watchTeamMembersListRequestFlow),
        fork(teams.watchResendMemberInviteRequestFlow),
        fork(teams.watchTeamBrandsListRequestFlow),
        fork(teams.watchGetBrandRequestFlow),
        fork(teams.watchCreateBrandRequestFlow),
        fork(teams.watchUpdateBrandRequestFlow),
        fork(teams.watchDeleteBrandRequestFlow),
        fork(teams.watchGetRolesRequestFlow),
        fork(teams.watchAddRoleRequestFlow),
        fork(teams.watchEditRoleNameRequestFlow),
        fork(teams.watchDeleteRoleRequestFlow),
        fork(teams.watchGetTeamPermissionsRequestFlow),
        fork(teams.watchSubmitRolesPermissionsRequestFlow),
        fork(teams.watchUpdateBusinessDetailsRequestFlow),
        fork(teams.watchGetBusinessDetailsRequestFlow),
        fork(teams.watchGetTeamWalletsFlow),
        fork(teams.watchGetWalletTransactionsFlow),
        fork(teams.watchUpdateOnboardingOptionsRequestFlow),
        fork(partiposter.watchSavePartiposterTagRequestFlow),
        fork(partiposter.watchDeletePartiposterTagRequestFlow),
        fork(partiposter.watchUpdatePartiposterTagRequestFlow),
        fork(partiposter.watchGetPartiposterTagListRequestFlow),
        fork(registrations.watchGetCampaignRequestFlow),
        fork(registrations.watchCreateCampaignRequestFlow),
        fork(registrations.watchUpdateCampaignRequestFlow),
        fork(registrations.watchGetResultsRequestFlow),
        fork(registrations.watchGetResultFiltersFlow),
        fork(registrations.watchGetPriorityRequestFlow),
        fork(registrations.watchExportRegistrationResultsRequestFlow),
        fork(registrations.watchMassRegistrationFlow),
        fork(registrations.watchMassApproveByUsernameFlow),
        fork(registrations.watchSavePriorityListOrderingFlow),
        fork(registrations.watchWaitlistOrderModeFlow),
        fork(registrations.watchUpdateRegistrationScheduleRequestFlow),
        fork(registrations.watchUpdateMarkAsViewed),
        fork(registrations.watchHighlightRegistration),
        fork(registrations.watchReorderWaitlist),
        fork(banners.watchGetBannerGroupsRequestFlow),
        fork(banners.watchGetBannersRequestFlow),
        fork(banners.watchDisableBannersRequestFlow),
        fork(banners.watchCreateBannersRequestFlow),
        fork(filters.watchSetTeamFilter),
        fork(filters.watchSetTeamCountryByCampaign),
        fork(filters.watchSetApiHeader),
        fork(campaigns.watchGetCampaignComments),
        fork(campaigns.watchAddCampaignComment),
        fork(campaigns.watchReplyCampaignComment),
        fork(campaigns.watchUpdateCampaignComment),
        fork(campaigns.watchDeleteCampaignComment),
        fork(campaigns.watchResolveThread),
        fork(campaignTemplates.watchCampaignTemplatesRequestFlow),
        fork(campaignTemplates.watchCreateCampaignByTemplateRequestFlow),
        fork(campaignTemplates.watchUpdateTemplateDataRequestFlow),
        fork(register.watchVerifyEmailRequestFlow),
        fork(register.watchSignupRequestFlow),
        fork(register.watchSendInviteRequestFlow),
        fork(register.watchSignDetailsRequestFlow),
        fork(register.watchInviteTeamMembersRequestFlow),
        fork(campaignTemplates.watchTemplateDetailRequestFlow),
        fork(campaignTemplates.watchTemplateFiltersRequestFlow),
        fork(campaignTemplates.watchSwitchTemplateFlow),
        fork(campaignTemplates.watchCampaignInfoRequestFlow),
        fork(campaignTemplates.watchCampaignScheduleRequestFlow),
        fork(campaignTemplates.watchCampaignTaskElementsRequestFlow),
        fork(campaignTemplates.watchUpdateCampaignInfoFlow),
        fork(campaignTemplates.watchUpdateCampaignScheduleFlow),
        fork(campaignTemplates.watchCampaignTaskElementsUpdateFlow),
        fork(campaignTemplates.watchCampaignTemplateSubmitFlow),
        fork(campaignTemplates.watchCampaignTemplatePaymentSummary),
        fork(campaignTemplates.watchUpdateCampaignTemplatePaymentSummary),
        fork(campaignTemplates.watchSendToEdit),
        fork(campaignTemplates.watchRequestPayment),
        fork(campaignTemplates.watchSendToReview),
        fork(campaignTemplates.watchPublishCampaignTemplate),
        fork(campaignTemplates.watchUnpublishGuidedTemplate),
        fork(campaignTemplates.watchUseGuidedTemplate),
        fork(campaignTemplates.watchDuplicateGuidedTemplate),
        fork(campaignTemplates.watchDeleteCampaignTemplateData),
        fork(campaignTemplates.watchExportTemplate),
        fork(campaignTemplates.watchGetGuidedTemplateList),
        fork(campaignTemplates.watchGetRecommendedGuidedTemplateList),
        fork(campaignTemplates.watchGetBrandsCountries),
        fork(campaigns.watchUpdateTotalEarning),
        fork(campaigns.watchPaidOutsideApp),
        fork(campaigns.watchSaveAdditionalPayment),
        fork(campaigns.watchUpdateServiceFee),
        fork(campaigns.watchUpdateTax),
        fork(campaigns.watchGetCampaignPaymentSummary),
        fork(campaigns.watchUpdateCampaignPaymentSummary),
        fork(campaigns.watchApplyPromoCode),
        fork(campaigns.watchUnapplyPromoCode),
        fork(campaigns.watchTogglePayWithBalance),
        fork(campaigns.watchSetToReadyForLaunch),
        fork(campaignReport.watchGetCampaignOverviewFlow),
        fork(campaignReport.watchGetCampaignPerformanceFlow),
        fork(campaignReport.watchGetTaskPerformanceFlow),
        fork(campaignReport.watchGetIndividualPerformanceFlow),
        fork(campaignReport.watchGetTopPerformersFlow),
        fork(campaignReport.watchGetIndividualPerformanceStatsFlow),
        fork(campaignReport.watchUpdateAmbassadorFavoriteFlow),
        fork(campaignReport.watchGetIndividualPerformanceFiltersFlow),
        fork(ambassador.watchUpdateAmbassadorFavoriteFlow),
        fork(ambassador.watchGetAmbassadorBrandsFlow),
        fork(ambassador.watchGetAmbassadorFiltersFlow),
        fork(ambassador.watchGetAmbassadorListFlow),
        fork(ambassador.watchGetBrandContentTypesFlow),
        fork(campaignReport.watchDownloadCampaignReportFlow),
        fork(campaignTemplates.watchPublishGuidedCampaignTemplate),
    ])
}
